

/// <reference path="CoreEntity.ts" />

// Generated class BankMovementBalance_ManagedObject

class BankMovementBalance_ManagedObject extends CoreEntity
{

    // Property: missingDocumentsCount
    set missingDocumentsCount(value:number) {
        this.setValueForKey(value, 'missingDocumentsCount');
    }
    get missingDocumentsCount():number {
        return this.valueForKey('missingDocumentsCount');
    }
    set missingDocumentsCountPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'missingDocumentsCount');
    }
    get missingDocumentsCountPrimitiveValue():number {
        return this.primitiveValueForKey('missingDocumentsCount');
    }

    // Property: movementCount
    set movementCount(value:number) {
        this.setValueForKey(value, 'movementCount');
    }
    get movementCount():number {
        return this.valueForKey('movementCount');
    }
    set movementCountPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'movementCount');
    }
    get movementCountPrimitiveValue():number {
        return this.primitiveValueForKey('movementCount');
    }

    // Property: uncategorizedCount
    set uncategorizedCount(value:number) {
        this.setValueForKey(value, 'uncategorizedCount');
    }
    get uncategorizedCount():number {
        return this.valueForKey('uncategorizedCount');
    }
    set uncategorizedCountPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'uncategorizedCount');
    }
    get uncategorizedCountPrimitiveValue():number {
        return this.primitiveValueForKey('uncategorizedCount');
    }
}
